import SkeletonBox from "@Components/SkeletonBox/SkeletonBox";

export const DetailsCardSkeleton = () => (
  <div className="flex items-center gap-2 md:gap-4">
    <SkeletonBox className="aspect-square size-20 shrink-0 rounded-md md:size-28" />
    <div className="flex flex-col gap-2">
      <SkeletonBox className="h-5 w-28 md:h-8 md:w-48" />
      <SkeletonBox className="h-4 w-36 md:w-48" />
    </div>
  </div>
);

export const ExchangeDetailsSkeleton = () => (
  <div className="flex w-full flex-col gap-6">
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <SkeletonBox className="h-4 w-24" />
        <SkeletonBox className="h-3 w-48" />
      </div>
      <div className="flex items-end gap-3">
        <div className="flex flex-1 flex-col gap-1">
          <SkeletonBox className="h-3 w-16" />
          <SkeletonBox className="h-14 w-full" />
        </div>
        <SkeletonBox className="mb-5 h-4 w-4 shrink-0" />
        <div className="flex flex-1 flex-col gap-1">
          <SkeletonBox className="h-3 w-16" />
          <SkeletonBox className="h-14 w-full" />
        </div>
      </div>
      <SkeletonBox className="h-14 w-full" />
    </div>
    <div className="flex flex-col gap-4">
      <SkeletonBox className="h-6 w-56" />
      <div className="flex flex-col gap-2">
        <SkeletonBox className="h-4 w-40" />
        <SkeletonBox className="h-14 w-full" />
      </div>
    </div>
  </div>
);

export const ActionSkeleton = () => (
  <div className="flex w-full flex-col gap-3">
    <SkeletonBox className="h-4 w-48" />
    <SkeletonBox className="h-12 w-full" />
  </div>
);
